<template>
  <div class="right_body_s">
    <Panel>
      <template v-slot:panel-top>
        <ToolBar
          class="infoActive_rumb"
          :listArr="resourceDataRows"          
          @edit="onEditPlatResource"
          @add="onAddPlatResource"
          @del="onDelResource"          
          isAdd
          isEdit
          isDel
        ></ToolBar>
      </template>
      <template v-slot:panel-main>
        <search-box :fromData="queryCondition" @onSubmitSearch="onQueryResourceTree"></search-box>
        <el-table
          :data="resourceDataRows"
          style="width: 100%;margin-bottom: 20px;"
          row-key="resourceId"
          border
          highlight-current-row
          @current-change="onChangeSelectedRow"
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        >
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column v-for="(item,index) in tableColumns" :prop="item.field" :label="item.title" :formatter="item.formatter" :width="item.width" :key="index"></el-table-column>
        </el-table>
      </template>
    </Panel>

    <!-- 新增 -->
    <ResourceNeWindow ref="resourceWindowRef" :title="resourceWindowTitle"  
                       :resourceDataRows="resourceDataRows"
                       :selectedResource="selectedResourceRow"
                       @onSubModifyResource="onSubModifyResource"
                       @onCance="onCloseResourceWindow"></ResourceNeWindow>
  </div>
</template> 

<script>
import { resource } from "api/auth.js";

import ToolBar from "components/btn/listBtn.vue";
import tabList from "components/table/listRadio.vue";
import Panel from "components/container/BasePanel.vue";
import searchBox from './ui/ResourceSearchComp.vue';
import ResourceService from './service/PlatformResource.service.js'
import ResourceNeWindow from './ui/ResourceNeWindow.vue'


export default {
  components: { ToolBar, tabList,Panel,searchBox ,ResourceNeWindow},
  data() {
    return {
      resourceRow:[],
      resourceDataRows:[],
      selectedResourceRow:undefined,//选中的行
      showResourceWindow:false,
      resourceWindowTitle:'平台资源-新增',
      queryCondition:{
        
      },
      tableColumns: [
        { field: "resourceName", title: "资源名称", sortable: true },
        { field: "sort", title: "资源排序", width: 100 },
        { field: "resourceHref", title: "资源URL" },
        { field: "resourceCode", title: "路由Name" },
        {
          field: "type",
          title: "资源类型",
          formatter(row) {
            return row.resourceType == 1
              ? "主模块"
              : row.resourceType == 2
              ? "子模块"
              : row.resourceType == 3
              ? "菜单"
              : "功能";
          }
        }
      ],
    };
  },
  created() {
    this.onQueryResourceTree({});
  },
  updated: function() {},
  methods: {
     ...ResourceService,
     /**
     * 查找资源树
     */
    onQueryResourceTree(queryCondition){
      var vm=this,submitCondition=queryCondition||{};
      vm.loadPlatResourceTree({page:1,pageSize:10000,searchCriteria:submitCondition},function(treeData){
           vm.resourceDataRows=treeData;
           console.log(vm.resourceDataRows)
      });
    },
     /**
     * 新增平台资源
     */
		onAddPlatResource(){
      let vm=this,resourceWindow=vm.$refs.resourceWindowRef,resourceForm=resourceWindow.resourceForm||{};
      resourceForm.isEdit = false;
      vm.resourceWindowTitle = "平台资源-新增"; 
      //初始数据
      if(vm.selectedResourceRow&&vm.selectedResourceRow.resourceId){				 
        resourceForm.parentResourceTxt= vm.selectedResourceRow.value;
        resourceForm.parentResourceId=vm.selectedResourceRow.resourceId;
      }else{
        resourceForm.parentResourceTxt="顶级";
        resourceForm.parentResourceId=0;
      }
      resourceWindow.resourceForm=resourceForm;
      //显示窗体
      vm.showResourceWindow = true;     
      resourceWindow.showWindow(vm.showResourceWindow);
    },
    /**
     * 编辑平台资源
     */
    onEditPlatResource(){
      let vm=this,resourceWindow=vm.$refs.resourceWindowRef,resourceForm=resourceWindow.resourceForm;
      vm.resourceWindowTitle = "平台资源-编辑"; 
			if(!vm.selectedResourceRow||!vm.selectedResourceRow.resourceId){
				vm.$message.error('请选择要编辑的资源');
				return;
      }
      // console.log(vm.selectedResourceRow)
      // console.log(vm.resourceDataRows)
      resourceWindow.resourceForm= JSON.parse(JSON.stringify(vm.selectedResourceRow));
      resourceWindow.resourceForm.isEdit = true;
      //填充数据
      let parentResource = vm.resourceDataRows.find(v=>v.resourceId === vm.selectedResourceRow.parentResourceId);
      if(parentResource){
        console.log(parentResource)
         resourceWindow.resourceForm.parentResourceTxt= parentResource.value;
         resourceWindow.resourceForm.parentResourceId=parentResource.resourceId;
      }else{
         resourceWindow.resourceForm.parentResourceTxt="顶级";
         resourceWindow.resourceForm.parentResourceId=0;
      }
      
      vm.resourceDataRows.forEach((item)=>{
        if(item.children){
          let parentResource_child = item.children.find(v=>v.resourceId === vm.selectedResourceRow.parentResourceId);
          if(parentResource_child){
            resourceWindow.resourceForm.parentResourceTxt= parentResource_child.value;
            resourceWindow.resourceForm.parentResourceId=parentResource_child.resourceId;
          }
        }
      })
      console.log(resourceWindow.resourceForm)
      //显示窗体
      vm.showResourceWindow = true;     
      resourceWindow.showWindow(vm.showResourceWindow);
    },
    /**
     * 新增或是修改资源
     */
    onSubModifyResource(resourceData){
       console.log(resourceData);
       let vm=this,resourceWindow=vm.$refs.resourceWindowRef;
       //提交数据
       vm.addPlatResource(resourceData,function(result){
           if(result.type=="S"){
                vm.isShowWindow=false;
                resourceWindow.resetForm();
                resourceWindow.showWindow(vm.isShowWindow);
                vm.$message.success(result.msg);                
                //重新加载资源
                vm.onQueryResourceTree();
           }else{
               console.log(result);
           }        
       });
    },
    /**
     * 关闭资源修改或新增窗口
     */
    onCloseResourceWindow(show){
        let vm=this;
        vm.isShowWindow=show;
    },
    /**
     * 更改表格选中行
     */
    onChangeSelectedRow(selectedRow){
      this.selectedResourceRow=selectedRow;
    },
    /**
     * 删除资源
     */
    onDelResource(){
      let vm=this;
      if(!vm.selectedResourceRow||!vm.selectedResourceRow.resourceId){
         vm.$message.error("请选择要删除的资源");
         return;
      }
      vm.$confirm("确定删除么, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消", 
          type: "warning"
      }).then(() =>{
          vm.submitDelResource(vm.selectedResourceRow);
      }).catch(() =>{
          vm.$message.success("已取消删除");
      });
    },
    /**
     * 提交删除记录
     */
    submitDelResource(delResource){
      let vm=this;
      // vm.$loading.show("正在删除请求...");
      vm.delPlatResource(delResource,function(result){
        if(result.type=="S"){ 
          vm.$message.success(result.msg);             
          //重新加载资源
          vm.onQueryResourceTree();
        }else{
            console.log(result);
        } 
      });
    }
  }
};
</script>
